module.exports = "/_next/static/images/findus-line-d4a16e3af27f6fe6a1e2aed87e7ad45b.svg";